import { render, staticRenderFns } from "./FnFormatEmail.vue?vue&type=template&id=10120192&"
import script from "./FnFormatEmail.vue?vue&type=script&lang=js&"
export * from "./FnFormatEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10120192')) {
      api.createRecord('10120192', component.options)
    } else {
      api.reload('10120192', component.options)
    }
    module.hot.accept("./FnFormatEmail.vue?vue&type=template&id=10120192&", function () {
      api.rerender('10120192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatEmail.vue"
export default component.exports